import { ChevronRight, UsersRound } from "lucide-react";
import { useState } from "react";
import type { GarmentOrder } from "../types";
import { GarmentSizeHistoryModal } from "./GarmentSizeHistoryModal";

type GarmentSizeHistoryProps = {
  garmentName: string;
  orders: GarmentOrder[];
};

export function GarmentSizeHistory({ garmentName, orders }: GarmentSizeHistoryProps) {
  const [isOpen, setIsOpen] = useState(false);
  if (orders.length === 0) return null;

  return (
    <>
      <button className="size-history-trigger" type="button" onClick={() => setIsOpen(true)}>
        <UsersRound size={17} aria-hidden="true" />
        <span>Se andras storlekar</span>
        <small>{orders.length}</small>
        <ChevronRight size={17} aria-hidden="true" />
      </button>
      {isOpen && (
        <GarmentSizeHistoryModal
          garmentName={garmentName}
          orders={orders}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
